import { render, staticRenderFns } from "./WeeklyPlanTable.vue?vue&type=template&id=3be11d34"
import script from "./WeeklyPlanTable.vue?vue&type=script&lang=js"
export * from "./WeeklyPlanTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports